import { useEffect, useState } from "react";
import { Link, useParams } from "react-router-dom";
import { ArrowRight, Sparkles } from "lucide-react";
import { getBusiness } from "@/lib/api";
import type { Business } from "@/lib/types";
import { BusinessCard } from "@/components/BusinessCard";
import { Orb } from "@/components/Orb";

export default function BusinessPage() {
  const { id } = useParams();
  const [business, setBusiness] = useState<Business | null>(null);
  const [error, setError] = useState<string | null>(null);

  useEffect(() => {
    if (!id) return;
    getBusiness(id).then(setBusiness).catch((e) => setError(String(e)));
  }, [id]);

  if (error) {
    return (
      <div className="flex min-h-dvh flex-col items-center justify-center text-center px-6">
        <Orb size={160} />
        <p className="mt-8 text-white/70">This reimagined business couldn't be found.</p>
        <Link to="/" className="btn-primary mt-6">
          Reimagine yours <ArrowRight className="h-4 w-4" />
        </Link>
      </div>
    );
  }

  if (!business) {
    return (
      <div className="flex min-h-dvh items-center justify-center">
        <Orb size={160} intensity="thinking" />
      </div>
    );
  }

  return (
    <div className="min-h-dvh px-5 py-8">
      <div className="mx-auto max-w-xl">
        <div className="text-center">
          <div className="inline-flex items-center gap-1.5 rounded-md border border-white/10 bg-white/5 px-3 py-1 text-xs uppercase tracking-widest text-white/60">
            <Sparkles className="h-3 w-3" /> Shared reimagined business · WTC Lisboa
          </div>
        </div>

        <BusinessCard business={business} className="mt-6" highlightCommitment />

        <Link to="/reimagine" className="btn-primary mt-6 w-full">
          Reimagine mine <ArrowRight className="h-4 w-4" />
        </Link>
      </div>
    </div>
  );
}
